import React from 'react';

import { Button } from '../../../../../../../components/Clickables/Buttons/Button';
import { useExplore } from '../../../../../context/ExploreContext';

export const ClearFiltersButton = ({ filterCount }: { filterCount: number }) => {
  const { saveParamsInUrl } = useExplore();
  return (
    <Button
      variant="buttonTertiary"
      onClick={() => {
        saveParamsInUrl({
          catchFiltersSpecies: undefined,
          catchFiltersMonths: undefined,
        });
      }}
      disabled={filterCount === 0}
    >
      Clear all filters
    </Button>
  );
};
